import React, { useState, useEffect, useContext } from 'react';
import './TrendingCompanies.css';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { AuthContext } from '../../App';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function TrendingCompanies({ setSelectedCompanyFromTrending }) {
  const [companies, setCompanies] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const companiesPerPage = 50;
  const { isPremiumUser } = useContext(AuthContext);
  const totalPages = Math.ceil(companies.length / companiesPerPage);
  const navigate = useNavigate();

  // Fetch data when the component mounts
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/company-questions-count`);
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        setCompanies(data);
      } catch (error) {
        console.error('Error fetching data: ', error);
      }
    };

    fetchData();
  }, []);

  // Handlers to change page
  const goToPreviousPage = () => {
    setCurrentPage((prev) => (prev > 1 ? prev - 1 : prev));
  };

  const goToNextPage = () => {
    setCurrentPage((prev) => (prev < totalPages ? prev + 1 : prev));
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value.toLowerCase());
  };

  const getFilteredCompanies = () => {
    return companies.filter((company) =>
      company.name.toLowerCase().includes(searchQuery)
    );
  };

  // Adjust getVisibleCompanies to use getFilteredCompanies
  const getVisibleCompanies = () => {
    const filteredCompanies = getFilteredCompanies();
    const startIndex = (currentPage - 1) * companiesPerPage;
    const endIndex = startIndex + companiesPerPage;
    return filteredCompanies.slice(startIndex, endIndex);
  };

  // Function to add a lock icon for non-premium users
  const renderCompanyItem = (company) => {
    return isPremiumUser ? company.name : `🔒 ${company.name}`;
  };

  const handleCompanyClick = (companyName) => {
    if (!isPremiumUser) {
      // Use toast notification instead of alert
      const message = (
        <div>
          This filter is available for premium users only. Try{' '}
          <span
            style={{ cursor: 'pointer', color: '#FFA115', fontWeight: 'bold' }}
            onClick={() => navigate('/premium')} // Navigate to the premium page onClick
          >
            Premium
          </span>{' '}
          now.
        </div>
      );

      // Display the toast notification with the clickable link
      toast(message, {
        autoClose: 10000, // Adjust the auto-close time as needed
        closeOnClick: false, // Prevent toast from closing when clicking the content
      });
    } else {
      // Premium user actions
      setSelectedCompanyFromTrending(companyName);
      // Navigate to filtered questions or other premium user action
    }
  };

  return (
    <div className="trending-companies">
      <div className="trending-header">
        <h2>Trending Companies</h2>
        <div className="pagination-controls">
          <button
            onClick={goToPreviousPage}
            disabled={currentPage === 1}
            className={currentPage === 1 ? 'disabled' : ''}
          >
            &lt;
          </button>
          <button
            onClick={goToNextPage}
            disabled={currentPage === totalPages}
            className={currentPage === totalPages ? 'disabled' : ''}
          >
            &gt;
          </button>
        </div>
      </div>
      <div className="search-container">
        <FontAwesomeIcon icon={faSearch} className="search-icon" />
        <input
          type="text"
          className="company-search"
          placeholder="Search for a company ..."
          aria-label="Search for a company"
          onChange={handleSearchChange}
        />
      </div>
      <div className="company-list">
        {getVisibleCompanies().map((company, index) => (
          <div key={index} className="company-item">
            <button
              className="company-name"
              onClick={() => handleCompanyClick(company.name)} // Always call handleCompanyClick
            >
              {renderCompanyItem(company)}
            </button>
            <span className="company-count">{company.count}</span>
          </div>
        ))}
      </div>
      <ToastContainer position="top-center" autoClose={10000} />
    </div>
  );
}

export default TrendingCompanies;